export interface InformationPayload {
  title: string;
  description: string;
  path: string;
  companyId?: string | null;
}

export const blacklistViewInformation = [
  "/setting",
  "/setting/masterdata",
  "/setting/company",
  "/setting/user-management",
  "/setting/job",
  "/setting/history",
  "/vocs-inventory",
  "/my-task",
];
